import TYPES from '../../types';

// Domain
import { LinkInvestorGoalsDto } from '../../domain/dtos/link-investor-goals-dto';
import { LinkSowosWealthRepository } from '../../domain/repositories/link-sowos-wealth-repository';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import Command from '@/modules/shared/domain/use-cases/command';

@Injectable()
export default class CreateLinkWealthV2Command extends Command<LinkInvestorGoalsDto> {
  @Inject(TYPES.LINK_SOWOS_WEALTH_REPOSITORY)
  private readonly repository!: LinkSowosWealthRepository;

  internalExecute(payload: LinkInvestorGoalsDto): Promise<void> {
    return this.repository.link_goals(payload);
  }
}
